import styles from './index.module.css'
const ColumnLayout = ({children,reverse,className}) => {
    return (
        <div className={`${styles.ctn} ${reverse ? styles.reverse : ''} ${className}`}>
            {
                children
            }
        </div>
    )
}

export default ColumnLayout